import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AnyKeyAnyType } from '../../shared-third-party/common.type';
import { Observable, of } from 'rxjs';

export interface ISimpleSearchRequest {
  query: string,
}
export interface ISimpleSearchResult {
  query: string,
  data: ISimpleSearchResultDataItem[],
}

export interface ISimpleSearchResultDataItem {
  type: string,
  value: string,
  meta: {
    text: string,
    description: string,
  }
}

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  url = environment.baseUrl + '/ajax/component/NewBuildingsLocations/search';

  constructor(private http: HttpClient,) {
  }

  getNewBuildingsLocation(queryParams: AnyKeyAnyType | null): Observable<any> {
    const res: ISimpleSearchResult = {query: '', data: []};
    if (queryParams) {
      return  this.http.get(this.url + '?' + SearchService.buildQueryString(queryParams));
    }

    return of(res);
  }

  /**
   * Формирует строку из параметров для гет запроса
   */
  static buildQueryString(params: AnyKeyAnyType, prefix = ''): string {
    const parts: string[] = [];

    for (const key in params) {
      if (!params[key]) {
        continue;
      }

      const value = params[key];

      if (value === null || value === undefined) {
        continue;
      }

      const paramKey = prefix ? prefix + '[' + key + ']' : key;

      if (typeof value === 'object') {
        parts.push(SearchService.buildQueryString(value, paramKey));
      } else {
        parts.push(encodeURIComponent(paramKey) + '=' + encodeURIComponent(value));
      }
    }

    return parts.join('&');
  }
}
